'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Typography from '@classify/react-core-components/Typography';
import Skeleton from '@classify/react-core-components/Skeleton';
import Box from '@classify/react-core-components/Box';
import { translate } from '@openclassrooms/translations';
import LearningOutcomesPassedSvg from '../../images/learning-outcomes-passed.svg';
type Props = {
  value: number;
  max: number;
  isLoading?: boolean;
};
export default function LearningOutcome(t0) {
  const $ = _c(10);
  const {
    value,
    max,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography component="span" variant="overline" sx={{
      mb: 1,
      display: "inline-block"
    }}>{translate("course.in_progress.learning_outcomes.label")}</Typography>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "& > * + *": {
        ml: 1
      }
    };
    t4 = <Image src={LearningOutcomesPassedSvg} alt="" width={32} height={32} />;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isLoading || $[4] !== max || $[5] !== value) {
    t5 = isLoading ? <Skeleton width={60} /> : <><Typography variant="h3" component="span" display="inline">{value}</Typography><Typography variant="h5" component="span" display="inline" sx={{
        fontWeight: "normal"
      }}>/{max}</Typography></>;
    $[3] = isLoading;
    $[4] = max;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isLoading || $[8] !== t5) {
    t6 = <Box>{t2}<Box sx={t3}>{t4}<span data-testid="learning-outcome" aria-busy={isLoading}>{t5}</span></Box></Box>;
    $[7] = isLoading;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}